<div
  class="flex flex-row items-center justify-around"
  (mouseenter)="isHovered = true"
  (mouseleave)="isHovered = false"
>
  <button
    class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
    data-testid="addBtn"
    title="Add to body"
    (click)="
      onAddToBody(
        managerControl.get(RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER()).value
      )
    "
  >
    <i class="icon icon-plus-circle"></i>
  </button>
  <div class="flex w-10/12 px-2 space-x-2 text-xs">
    <p data-testid="managerName">
      {{
        managerControl.get(RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER()).value
          .firstName +
          " " +
          managerControl.get(RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER())
            .value.lastName
      }}
    </p>
    <app-ai-icon
      *ngIf="isSmartLinked"
      class="text-project-2100"
      label="Added by smart linking"
      data-testid="smartLinkedMarker"
    ></app-ai-icon>
    <p
      *ngIf="
        handleManagerRating(
          managerControl.get(RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER())
            .value.rating
        )
      "
      class="content-center text-xs text-project-2400"
      data-testid="managerRating"
    >
      {{
        managerControl.get(RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER()).value
          .rating
      }}
    </p>
  </div>
  <button
    *ngIf="isHovered && isSurtitleButtonShown"
    data-testid="surtitleBtn"
    title="Promote Surtitle"
    (click)="
      promoteToSurtitle(
        managerControl.get(RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER()).value
      )
    "
    class="h-4 text-xxs whitespace-nowrap hover:text-project-300 pr-1"
  >
    Use as Surtitle
  </button>
  <button
    class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
    data-testid="infoBtn"
    title="info"
    (click)="
      onInfoClick(
        managerControl.get(RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER()).value
      )
    "
  >
    <i class="icon icon-info-circle"></i>
  </button>
  <button
    class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
    data-testid="removeBtn"
    title="Remove"
    (click)="
      onRemove(
        managerControl.get(RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER()).value
      )
    "
  >
    <i class="icon icon-minus-circle"></i>
  </button>
</div>
<div class="flex flex-col justify-between p-1 text-xs bg-project-800">
  <div class="flex flex-row flex-1 w-full">
    <p class="flex flex-1" data-testid="sectorName">
      {{ getSectorDescription() }}
    </p>
    <button
      (click)="toggleShowSectorChange()"
      class="text-project-2100"
      data-testid="changeSector"
    >
      ({{ isChangingSector ? "cancel" : "change" }})
    </button>
  </div>
  <div *ngIf="isChangingSector" class="flex flex-1 w-full my-1">
    <mat-select
      class="p-1 px-1 py-2 text-xs bg-project-1300"
      [formControl]="
        managerControl.get(RELATED_MANAGER_FORM_PATHS.SELECTED_SECTOR())
      "
      [compareWith]="compareSelectedSector"
      data-testid="changeSectorDropdown"
    >
      <mat-option [value]="ALL_SECTORS_SELECTED">
        {{ ALL_SECTORS_SELECTED.name }}
      </mat-option>
      <mat-option
        *ngFor="
          let sector of managerControl.get(
            RELATED_MANAGER_FORM_PATHS.SELECTED_MANAGER()
          ).value.sectors
        "
        [value]="sector"
        data-testid="sectorOptions"
      >
        {{ sector.name }}
      </mat-option>
      <mat-option [value]="NO_SECTORS_SELECTED">
        {{ NO_SECTORS_SELECTED.name }}
      </mat-option>
    </mat-select>
  </div>
</div>
